import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "@vilocnv/allsetra-core";
import i18n from "i18next";
import { deleteKey } from "domain/keys/api/delete-key";
import { KeyActionRequestDto } from "domain/keys/entities/dtos/key-action-request.dto";

const deleteKeyAction = createAsyncThunk(
  "keys/deleteKeyAction",
  async (request: KeyActionRequestDto, thunkAPI) => {
    try {
      return await deleteKey(request);
    } catch (error: any) {
      console.error(error);
      toast.error(i18n.t("toasts.deleteKeyError"));
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export default deleteKeyAction;
